// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hc-6";
export var emphasizeQuantity = "_hc-3";
export var flatBottomCorners = "_hc-5";
export var productImage = "_hc-0";
export var quantityContainer = "_hc-2";
export var tooltip = "_hc-1";
export var wrapAndEllipsesOverflow = "_hc-4";